// extracted by mini-css-extract-plugin
export var autoExpand = "_1i-8";
export var container = "_1i-7";
export var containerWidth = "_1i-5";
export var disabled = "_1i-2";
export var error = "_1i-3";
export var fullWidth = "_1i-6";
export var inputWrapper = "_1i-0";
export var small = "_1i-1";
export var textarea = "_1i-4";